import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HomeUiService } from '../home-ui.service';
import { I18n } from '../../i18n.service';

@Component({
  selector: 'app-habit-description-modal',
  templateUrl: './habit-description-modal.component.html',
  styleUrls: ['./habit-description-modal.component.scss'],
})
export class HabitDescriptionModalComponent implements OnInit {
  @Input() habitLevel;

  constructor(private modal: ModalController, public homeUiService: HomeUiService, private i18n: I18n) {}

  ngOnInit() {}

  closePopup() {
    this.modal.dismiss();
  }
}
